import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const MenuLine = ({ width = 26, height = 26, fill = '#898C8E', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.47917 19.104C5.24896 19.104 5.05604 19.0261 4.9004 18.8703C4.74458 18.7147 4.66667 18.5217 4.66667 18.2913C4.66667 18.0611 4.74458 17.8681 4.9004 17.7125C5.05604 17.557 5.24896 17.4793 5.47917 17.4793H22.2708C22.501 17.4793 22.694 17.5571 22.8496 17.7128C23.0054 17.8686 23.0833 18.0617 23.0833 18.2921C23.0833 18.5223 23.0054 18.7152 22.8496 18.8709C22.694 19.0263 22.501 19.104 22.2708 19.104H5.47917ZM5.47917 13.8125C5.24896 13.8125 5.05604 13.7346 4.9004 13.5788C4.74458 13.423 4.66667 13.2299 4.66667 12.9997C4.66667 12.7693 4.74458 12.5764 4.9004 12.421C5.05604 12.2653 5.24896 12.1875 5.47917 12.1875H22.2708C22.501 12.1875 22.694 12.2654 22.8496 12.4212C23.0054 12.577 23.0833 12.7701 23.0833 13.0003C23.0833 13.2307 23.0054 13.4236 22.8496 13.579C22.694 13.7347 22.501 13.8125 22.2708 13.8125H5.47917ZM5.47917 8.52069C5.24896 8.52069 5.05604 8.44287 4.9004 8.28723C4.74458 8.13141 4.66667 7.9383 4.66667 7.70792C4.66667 7.47771 4.74458 7.28478 4.9004 7.12915C5.05604 6.97369 5.24896 6.89596 5.47917 6.89596H22.2708C22.501 6.89596 22.694 6.97387 22.8496 7.12969C23.0054 7.28533 23.0833 7.47834 23.0833 7.70873C23.0833 7.93894 23.0054 8.13186 22.8496 8.2875C22.694 8.44296 22.501 8.52069 22.2708 8.52069H5.47917Z"
        fill={fill}
      />
    </Svg>
  );
};

export default MenuLine;
